import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import './Patients.css';

function Payments() {
    const [payments, setPayments] = useState([]);
    const [patientsList, setPatientsList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [currentPayment, setCurrentPayment] = useState({ id: null, patient_id: '', amount: '', payment_method: 'cash', description: '', payment_date: '' });
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');

    useEffect(() => {
        fetchPayments();
        fetchPatients();
    }, []);

    const fetchPayments = () => {
        axios.get('./backend/get_payments.php')
            .then(res => {
                setPayments(Array.isArray(res.data) ? res.data : []);
                setLoading(false);
            })
            .catch(err => {
                console.error(err);
                setLoading(false);
            });
    };

    const fetchPatients = () => {
        axios.get('./backend/get_patients.php')
            .then(res => {
                if (Array.isArray(res.data)) setPatientsList(res.data);
            })
            .catch(err => console.error(err));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        axios.post('./backend/save_payment.php', currentPayment)
            .then(res => {
                toast.success(res.data.message);
                setShowModal(false);
                fetchPayments();
            })
            .catch(err => toast.error('İşlem başarısız.'));
    };

    const handleDelete = (id) => {
        if(window.confirm('Bu ödemeyi silmek istediğinize emin misiniz?')) {
            axios.post('./backend/delete_payment.php', { id })
                .then(res => {
                    toast.success(res.data.message);
                    fetchPayments();
                });
        }
    };

    const openModal = (payment = { id: null, patient_id: '', amount: '', payment_method: 'cash', description: '', payment_date: new Date().toISOString().slice(0, 16) }) => {
        setCurrentPayment(payment);
        setShowModal(true);
    };

    const getMethodText = (method) => {
        switch(method) {
            case 'cash': return 'Nakit';
            case 'credit_card': return 'Kredi Kartı';
            case 'transfer': return 'Havale/EFT';
            default: return method;
        }
    };

    if (loading) return <div>Yükleniyor...</div>;

    // Tarih Filtreleme
    const filteredPayments = payments.filter(p => {
        if (!startDate && !endDate) return true;
        const paymentDate = new Date(p.payment_date);
        const start = startDate ? new Date(startDate) : new Date('1900-01-01');
        const end = endDate ? new Date(endDate) : new Date('2100-01-01');
        end.setHours(23, 59, 59, 999); // Günün sonuna kadar
        return paymentDate >= start && paymentDate <= end;
    });

    const totalIncome = filteredPayments.reduce((sum, p) => sum + parseFloat(p.amount), 0);

    return (
        <div className="patients-container">
            <div className="header-actions">
                <h2>Ödemeler ve Gelir Takibi</h2>
                <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                    <input type="date" value={startDate} onChange={e => setStartDate(e.target.value)} style={{ padding: '8px', borderRadius: '20px', border: '2px solid #eaecf4' }} />
                    <span style={{color: '#858796'}}>-</span>
                    <input type="date" value={endDate} onChange={e => setEndDate(e.target.value)} style={{ padding: '8px', borderRadius: '20px', border: '2px solid #eaecf4' }} />
                    <button className="add-btn" onClick={() => openModal()}>+ Yeni Ödeme Al</button>
                </div>
            </div>

            <div style={{ display: 'flex', gap: '20px', marginBottom: '20px' }}>
                <div style={{ flex: 1, background: 'white', padding: '20px', borderRadius: '15px', boxShadow: '0 5px 15px rgba(0,0,0,0.05)', borderLeft: '5px solid #1cc88a' }}>
                    <h3 style={{ margin: 0, color: '#5a5c69', fontSize: '0.9rem', textTransform: 'uppercase' }}>Toplam Gelir</h3>
                    <p style={{ fontSize: '1.8rem', fontWeight: 'bold', color: '#1cc88a', margin: '10px 0 0 0' }}>{totalIncome.toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺</p>
                </div>
            </div>

            <table className="data-table">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Tarih</th>
                        <th>Hasta</th>
                        <th>Tutar</th>
                        <th>Yöntem</th>
                        <th>Açıklama</th>
                        <th style={{textAlign: 'right'}}>İşlemler</th>
                    </tr>
                </thead>
                <tbody>
                    {filteredPayments.map(p => (
                        <tr key={p.id}>
                            <td data-label="ID">{p.id}</td>
                            <td data-label="Tarih">{new Date(p.payment_date).toLocaleString()}</td>
                            <td data-label="Hasta">{p.patient_name}</td>
                            <td data-label="Tutar" style={{fontWeight: 'bold', color: '#1cc88a'}}>{parseFloat(p.amount).toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺</td>
                            <td data-label="Yöntem">{getMethodText(p.payment_method)}</td>
                            <td data-label="Açıklama">{p.description}</td>
                            <td data-label="İşlemler">
                                <div className="action-buttons" style={{justifyContent: 'flex-end'}}>
                                    <button className="edit-btn" onClick={() => openModal(p)}>Düzenle</button>
                                    <button className="delete-btn" onClick={() => handleDelete(p.id)}>Sil</button>
                                </div>
                            </td>
                        </tr>
                    ))}
                    {filteredPayments.length === 0 && <tr><td colSpan="7" style={{textAlign:'center'}}>Kayıtlı ödeme bulunamadı.</td></tr>}
                </tbody>
            </table>

            {showModal && (
                <div className="modal-overlay">
                    <div className="modal">
                        <div className="modal-header">
                            <h3>{currentPayment.id ? 'Ödeme Düzenle' : 'Yeni Ödeme Al'}</h3>
                            <button className="close-modal-btn" onClick={() => setShowModal(false)}>✕</button>
                        </div>
                        <div className="modal-body">
                            <form id="paymentForm" onSubmit={handleSubmit}>
                                <div className="form-group">
                                    <label>Hasta Seçiniz</label>
                                    <select value={currentPayment.patient_id} onChange={e => setCurrentPayment({...currentPayment, patient_id: e.target.value})} required style={{ width: '100%', padding: '12px', borderRadius: '10px', border: '2px solid #eaecf4' }}>
                                        <option value="">Seçiniz...</option>
                                        {patientsList.map(p => (
                                            <option key={p.id} value={p.id}>{p.full_name}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="form-group">
                                    <label>Tutar (TL)</label>
                                    <input type="number" step="0.01" value={currentPayment.amount} onChange={e => setCurrentPayment({...currentPayment, amount: e.target.value})} required />
                                </div>
                                <div className="form-group">
                                    <label>Ödeme Yöntemi</label>
                                    <select value={currentPayment.payment_method} onChange={e => setCurrentPayment({...currentPayment, payment_method: e.target.value})} style={{ width: '100%', padding: '12px', borderRadius: '10px', border: '2px solid #eaecf4' }}>
                                        <option value="cash">Nakit</option>
                                        <option value="credit_card">Kredi Kartı</option>
                                        <option value="transfer">Havale/EFT</option>
                                    </select>
                                </div>
                                <div className="form-group">
                                    <label>Tarih</label>
                                    <input type="datetime-local" value={currentPayment.payment_date} onChange={e => setCurrentPayment({...currentPayment, payment_date: e.target.value})} />
                                </div>
                                <div className="form-group">
                                    <label>Açıklama</label>
                                    <textarea value={currentPayment.description} onChange={e => setCurrentPayment({...currentPayment, description: e.target.value})} style={{ width: '100%', padding: '10px', borderRadius: '10px', border: '2px solid #eaecf4' }} />
                                </div>
                            </form>
                        </div>
                        <div className="modal-actions">
                            <button type="button" className="cancel-btn" onClick={() => setShowModal(false)}>İptal</button>
                            <button type="submit" form="paymentForm" className="save-btn">Kaydet</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Payments;